<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :label-width="100">
        <Row>
          <!--          <Col :span="5">-->
          <!--            <FormItem label="预案类型">-->
          <!--              <Select v-model="PreliminaryPlanForm.planType" style="width: 80%" @on-change.once="getPreliminaryPlanData"-->
          <!--                      @on-clear.once="getPreliminaryPlanData"-->
          <!--                      clearable>-->
          <!--                <Option v-for="(item,index) in preplanTypeList" :key="index" :value="item.id"-->
          <!--                        :label="item.name"></Option>-->
          <!--              </Select>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <Col :span="5">
            <FormItem label="预案类别">
              <Select v-model="PreliminaryPlanForm.planCategory" style="width: 80%"
                      @on-change.once="getPreliminaryPlanData"
                      @on-clear.once="getPreliminaryPlanData"
                      clearable>
                <Option v-for="(item,index) in preplanCategoryList" :key="index" :value="item.id"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="5">
            <FormItem label="区县">
              <Select v-model="PreliminaryPlanForm.countyId" @on-change="getPreliminaryPlanData" clearable
                      @on-clear.once="getPreliminaryPlanData">
                <Option v-for="(item,index) in countyList" :key="index" :value="item.indexCode"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
          </Col>
          <!--          <Col :span="5">-->
          <!--            <FormItem label="区域">-->
          <!--              <Select v-model="PreliminaryPlanForm.area" @on-change.once="getPreliminaryPlanData" clearable-->
          <!--                      @on-clear.once="getPreliminaryPlanData">-->
          <!--                <Option v-for="(item,index) in AreaList" :key="index" :value="item.id"-->
          <!--                        :label="item.name"></Option>-->
          <!--              </Select>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <Col :span="2" offset="1">
            <Button type="primary" @click="goAddPrePlan">添加预案</Button>
          </Col>
        </Row>
      </Form>
      <Table
        :loading="PreliminaryPlanLoading"
        :columns="PreliminaryPlanColumns"
        :data="PreliminaryPlanData"
        :border="false"
        :stripe="true"
        :highlight-current-row="true"
      >
        <template slot-scope="{ row }" slot="action">
          <el-button type="text" size="small" style="margin-right: 5px" @click="showPrePlan(row)">查看</el-button>
          <el-button type="text" size="small" style="margin-right: 5px" @click="editPrePlan(row)">修改</el-button>
          <Poptip
            confirm
            transfer
            title="确定删除该预案？"
            @on-ok="removePrePlan(row)">
            <el-button type="text" size="small">删除</el-button>
          </Poptip>
        </template>
      </Table>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            :loading="PreliminaryPlanLoading"
            :total="PreliminaryPlanTotal"
            :page-size="PreliminaryPlanPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="PreliminaryPlanCurrentPage"
            @on-change="PreliminaryPlanPageChange"
            @on-page-size-change="PreliminaryPlanPageSizeChange"
      ></Page>
    </Card>
    <Modal v-model="showPrePlanModalIsShow">
      <el-descriptions title="预案信息">
        <el-descriptions-item label="预案号">{{ PrePlanInfo.id }}</el-descriptions-item>
        <el-descriptions-item label="预案名称">{{ PrePlanInfo.planName }}</el-descriptions-item>
        <el-descriptions-item label="预案类型">{{ PrePlanInfo.planCategoryName }}</el-descriptions-item>
        <el-descriptions-item label="预案类别">{{ PrePlanInfo.planTypeName }}</el-descriptions-item>
        <el-descriptions-item label="是否现场指挥">{{ PrePlanInfo.isLive ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ PrePlanInfo.createUserName }}</el-descriptions-item>
        <el-descriptions-item label="创建区县">{{ PrePlanInfo.createDeptName }}</el-descriptions-item>
        <el-descriptions-item label="附件"><a
          :href="$downloadUrl+PrePlanInfo.planFilePath">{{ $downloadUrl + PrePlanInfo.planFilePath }}</a>
        </el-descriptions-item>
      </el-descriptions>
    </Modal>
  </div>
</template>
<script>
import {PreliminaryColumns} from './js/PreliminaryColumns'

export default {
  data() {
    return {
      showPrePlanModalIsShow: false,
      PreliminaryPlanForm: {
        preplanType: null,// 预案类型
        preplanCategory: null,// 预案类别
        // street: null, // 市
        // area: null, // 县
        countyId: null
      },
      PreliminaryPlanLoading: false,
      PreliminaryPlanTotal: 0,
      PreliminaryPlanColumns: PreliminaryColumns,
      PreliminaryPlanData: [],
      PreliminaryPlanPageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      PreliminaryPlanCurrentPage: 1,
      preplanCategoryList: [], // 预案类别
      preplanTypeList: [], // 预案类型
      streetsList: [], // 区县
      AreaList: [], // 街道
      PrePlanInfo: {},
      countyList: []
    }
  },
  mounted() {
    this.getCountyList()
    this.getPreplanCategoryList()
    this.getPreplanTypeList()
  },
  methods: {
    getCountyList() {
      this.$http.get(`/api/getLowerLevelDepts?flag=3`).then(res => {
        if (res.status === 200) {
          this.countyList = res.data
          this.PreliminaryPlanForm.countyId = res.data[0].indexCode
          this.$nextTick(() => {
            this.getPreliminaryPlanData()
          })
        }
      })
    },
    editPrePlan(row) {
      this.$router.push({name: 'AddPrePlan', query: {preId: row.id, isEdit: true}})
    },
    removePrePlan(row) {
      let id = row.id
      this.$http.delete(`/api/planManagements/${id}`).then(res => {
        if (res) {
          this.$Message.success('删除成功')
          this.getPreliminaryPlanData()
        } else {
          this.$Message.error('删除失败')
        }
      }).catch(() => {
        this.$Message.error('删除失败')
      })
    },
    showPrePlan(row) {
      this.getPrePlanInfo(row.id)
    },
    // 获取预案信息
    getPrePlanInfo(value) {
      this.$http.get(`/api/planManagements/${value}`).then(res => {
        if (res.status === 200) {
          console.log(res.data)
          this.showPrePlanModalIsShow = true
          this.PrePlanInfo = res.data
          this.PrePlanInfo.planFilePath =  res.data.planFilePath.split('1433223')[1]
        } else {
          this.$Message.error('获取预案信息失败')
        }
      })
    },
    // 获取预案类别
    getPreplanCategoryList() {
      this.$http.get(`/api/planCategorys`).then(res => {
        if (res.status === 200) {
          this.preplanCategoryList = res.data.data
        }
      })
    },
    // 获取预案类型
    getPreplanTypeList() {
      this.$http.get(`/api/planTypes`).then(res => {
        if (res.status === 200) {
          this.preplanTypeList = res.data.data
        }
      })
    },
    // 获取区县
    getStreets() {
      this.$http.get(`/api/street/streets`).then(res => {
        if (res.status === 200) {
          console.log(res)
          this.streetsList = res.data.data
        }
      })
    },
    getAreaByStreetId() {
      this.$http.get(`/api/street/${this.PreliminaryPlanForm.street}`).then(res => {
        if (res.status === 200) {
          this.AreaList = res.data.data
        }
      })
    },
    getPreliminaryPlanData() {
      this.PreliminaryPlanLoading = true
      if (this.PreliminaryPlanForm.countyId === undefined) {
        this.PreliminaryPlanForm.countyId = this.countyList[0].indexCode
      }
      let requestData = {
        planType: this.PreliminaryPlanForm.planType === '' ? null : this.PreliminaryPlanForm.planType,
        planCategory: this.PreliminaryPlanForm.planCategory === '' ? null : this.PreliminaryPlanForm.planCategory,
        createDept: this.PreliminaryPlanForm.countyId === '' ? null : this.PreliminaryPlanForm.countyId,
        // area: this.PreliminaryPlanForm.area === '' ? null : this.PreliminaryPlanForm.area,
        size: this.PreliminaryPlanPageSize,
        page: this.PreliminaryPlanCurrentPage
      }
      this.$http.post('/api/getPlanList', requestData).then(res => {
        this.PreliminaryPlanData = res.data.data
        this.PreliminaryPlanLoading = false
        this.PreliminaryPlanTotal = res.data.recordsTotal
      })
    },
    goAddPrePlan() {
      this.$router.push({name: 'AddPrePlan'})
    },
    PreliminaryPlanPageChange(page) {
      this.PreliminaryPlanCurrentPage = page
      this.getPreliminaryPlanData()
    },
    PreliminaryPlanPageSizeChange(pageSize) {
      this.PreliminaryPlanPageSize = pageSize
      this.getPreliminaryPlanData()
    }
  },
}
</script>
<style scoped>

</style>

